<template>
  <div class="col" style="margin-top: 150px">
    <div class="row" style="display: flex; justify-content: space-around;">
      <b-card
        class="mv-card"
        header-class="text-center"
        title="Allgemeine Geschäftsbedingungen"
        style="margin: 2px; width: 100%;">
        <template v-slot:header>
          <!-- <i class="mdi mdi-newspaper-variant-multiple" style="font-size: 32px;"></i> -->
          <b-icon icon="newspaper" style="font-size: 32px;"></b-icon>
        </template>
        <div style="border: solid;">
          <glcwc-content-text-only
            content-key="YE-EA5vxq_XIlY5Bd0xclQ" />
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  }
}
</script>
<style scoped>
.cmpn-card-item {
  display: flex;
  flex: 1 0 auto;
  min-width: 200px;
  width: 45%;
}
</style>
